import { render, staticRenderFns } from "./PopoverSmall.vue?vue&type=template&id=0684a8dd&scoped=true&"
import script from "./PopoverSmall.vue?vue&type=script&lang=js&"
export * from "./PopoverSmall.vue?vue&type=script&lang=js&"
import style0 from "./PopoverSmall.vue?vue&type=style&index=0&id=0684a8dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684a8dd",
  null
  
)

export default component.exports